import React, { ReactElement } from 'react';
import { Spin } from 'common/components/antd/Spin/Spin';
import { useGetMainCounterpartyQuery } from 'domains/counterparties/queries/counterparty.query';
import { SContainer, SCounterpartyLogo, SCounterpartyName } from './HeaderLayoutCounterpartyName.style';

const HeaderLayoutCounterpartyName = (): ReactElement => {
  const {
    data: counterpartyData,
    isLoading: isCounterpartyDataLoading
  } = useGetMainCounterpartyQuery();

  const stringToHslColor = (value: string): string => {
    const saturation = 50;
    const lightness = 50;
    let hash: number = 0;

    for (let i = 0; i < value.length; i += 1) {
      hash = value.charCodeAt(i) + (Number(hash < 5) - hash);
    }

    const h = hash % 360;

    return `hsl(${h}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <SContainer>
      <Spin spinning={isCounterpartyDataLoading}>
        <SCounterpartyLogo backgroundColor={stringToHslColor(counterpartyData?.name || '')}>
          {counterpartyData?.name?.[0]}
        </SCounterpartyLogo>
      </Spin>
      <SCounterpartyName>{counterpartyData?.name}</SCounterpartyName>
    </SContainer>
  );
}

export default HeaderLayoutCounterpartyName;
